import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { SidebarContext } from "context/SidebarContext";
import VendorServices from "services/VendorServices";
import { notifyError, notifySuccess } from "utils/toast";
import FranchisePageServices from "services/FranchiseService";

const useFranchiseSubmit = (id, onModalOpen) => {
  const {
    isDrawerOpen,
    closeDrawer,
    setIsUpdate,
    selectedVendorValue,
    setSelectedVendorValue,
    setSelectedCompanyValue,
    selectedCompanyValue,
    fleetContent,
    setFleetContent,
    companyContent,
    setCompanyContent,
  } = useContext(SidebarContext);
  const [selectedYear, setSelectedYear] = useState(null);
  const [step, setStep] = useState(1);
  const [idProofUrl, setIDProofUrl] = useState("");
  const [panUrl, setPanUrl] = useState("");
  const [gstUrl, setGstUrl] = useState("");
  const [checkLeafUrl, setCheckLeafUrl] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [selectedServices, setSelectedServices] = useState([]);
  const [selectedState, setSelectedState] = useState(null);
  const [patternProof, setPatternProof] = useState(/^\d{12}$/);
  const [palaceholderProof, setPalaceholderProof] = useState("xxxxxxxx4345");
  const [selectedCity, setSelectedCity] = useState(null);
  const [selectedCountryId, setSelectedCountryId] = useState(null);
  const [selectedCountryCode, setSelectedCountrycode] = useState("");
  const [selectedRole, setselectedRole] = useState("");
  const [selectedProof, setselectedProof] = useState("");
  const [selectedCities, setSelectedCities] = useState([]);
  const [selectedRadioValueGender, setSelectedRadioValueGender] = useState("");
  const [selectedFleetTypeValue, setSelectedFleetTypeValue] = useState("");
  const [selectedServiceState, setSelectedServiceState] = useState([]);
  const [loading, setLoading] = useState(false);
  const [registrationDocumentUrl, setRegistrationDocumentUrl] = useState("");
  const [agreementPdfUrl, setAgreementPdfUrl] = useState("");

  const {
    register,
    handleSubmit,
    setValue,
    clearErrors,
    trigger,
    setError,
    formState: { errors },
  } = useForm();

  const handleServiceChange = (value) => {
    setSelectedServices((prev) => {
      const newServices = prev.includes(value)
        ? prev.filter((v) => v !== value)
        : [...prev, value];
      setValue("service_type", newServices); // Sync form state
      return newServices;
    });
  };
  const handleYearChange = (date) => {
    setSelectedYear(date);
  };

  const handleCountryChange = (country_code, country_id) => {
    setSelectedCountryId(country_id);
    setSelectedCountrycode(country_code);
  };
  const handleStateChange = (state_id) => {
    setSelectedState(state_id);
    // setSelectedCities([]);
  };
  const handleServiceStateChange = (states) => {
    setSelectedServiceState(states);
  };
  const handleCityChange = (city_id) => {
    setSelectedCity(city_id);
  };
  const handleChangeVendorType = (value) => {
    setSelectedVendorValue(value);

    if (selectedCompanyValue === "Company") {
      setCompanyContent(1);
    } else if (selectedCompanyValue === "Non-Company") {
      setCompanyContent(0);
    } else {
      setCompanyContent(0);
      setFleetContent(0);
    }
  };
  const handleChangeCompany = (value) => {
    setSelectedCompanyValue(value);
    if (value === "Company") {
      setCompanyContent(1);
    } else {
      setCompanyContent(0);
    }
  };
  const handleChangeRadioGender = (value) => {
    setSelectedRadioValueGender(value);
  };
  const handleChangeFleetType = (value) => {
    setSelectedFleetTypeValue(value);
  };

  const handleChangeProof = (value) => {
    setselectedProof(value);
    if (value === "1") {
      setPatternProof(/^\d{12}$/);
      setPalaceholderProof("xxxx xxxx 4345");
    } else if (value === "2") {
      setPatternProof(/^[A-Z]{3}[0-9]{7}$/);
      setPalaceholderProof("XGN3002623");
    } else if (value === "3") {
      setPatternProof(/^[A-PR-WY][1-9]\d\s?\d{4}[1-9]$/);
      setPalaceholderProof("A1234567");
    }
  };
  const validateImage = () => {
    let valid = true;

    // Step 2
    if (step === 2) {
      if (!registrationDocumentUrl) {
        setError("registration_document_img", {
          type: "manual",
          message: "Registration Document is required!",
        });
        valid = false;
      } else {
        clearErrors("registration_document_img");
      }

      if (!agreementPdfUrl) {
        setError("agreement_pdf", {
          type: "manual",
          message: "Agreement PDF is required!",
        });
        valid = false;
      } else {
        clearErrors("agreement_pdf");
      }
    }

    // Step 3
    if (step === 3) {
      if (!panUrl) {
        setError("panUrl", {
          type: "manual",
          message: "PAN Card is required!",
        });
        valid = false;
      } else {
        clearErrors("panUrl");
      }
    }

    // Step 4
    if (step === 4) {
      if (!checkLeafUrl) {
        setError("checkLeafUrl", {
          type: "manual",
          message: "Check Leaf is required!",
        });
        valid = false;
      } else {
        clearErrors("checkLeafUrl");
      }
    }

    return valid;
  };

  const validateForm = async () => {
    const isValid = await trigger();

    let hasError = false;

    if (selectedServiceState.length === 0) {
      setError("service_state", {
        type: "manual",
        message: "Please select at least one service state.",
      });
      hasError = true;
    } else {
      clearErrors("service_state");
    }

    if (selectedCities.length === 0) {
      setError("service_city", {
        type: "manual",
        message: "Please select at least one service city.",
      });
      hasError = true;
    } else {
      clearErrors("service_city");
    }

    return isValid && !hasError;
  };
  const handleNextStep = async () => {
    const formValid = await validateForm();
    const imageValid = validateImage();

    if (formValid && imageValid && step < 4) {
      setStep((prev) => prev + 1);
    }
  };
  //   const handleNextStep = async () => {
  //     await Promise.all([validateForm(), validateImage()]);
  //     if (Object.keys(errors).length === 0) {
  //      if (step < 4) {
  //     setStep((prev) => prev + 1);
  // }
  //     }
  //   };

  const handlePreviousStep = async () => {
    await Promise.all([validateForm(), validateImage()]);

    setStep(step - 1);
  };
  const goToStep = async (stepNumber) => {
    await Promise.all([validateForm(), validateImage()]);
    if (Object.keys(errors).length === 0) {
      setStep(stepNumber);
    }
  };
  // const validateForm = async () => {
  //   await trigger();

  //   return Object.keys(errors).length;
  // };

  const onSubmit = async (data) => {
    setLoading(true);

    try {
      const stateIds = selectedServiceState
        .map((state) => {
          if (typeof state === "string") return Number(state);
          if (typeof state === "object") return Number(state.value);
          return null;
        })
        .filter(Boolean);

      const payload = {
        // Basic Details
        company_name: data.company_name,
        owner_name: data.owner_name,
        phone_no: data.phone_no,
        // email_id: data.email_id,
        email_id: data.email_id?.trim().toLowerCase(),

        password: data.password,

        // Address
        address: data.address,
        // city_id: selectedCity,
        // state_id: selectedState,
        city_id: selectedCity?.value || null,
        state_id: selectedState?.value || null,
        pincode: data.pincode,

        // Service Details
        service_cities: selectedCities,
        service_states: stateIds,

        // PAN & GST
        pan_number: data.pan_number,
        pan_img: panUrl,

        gst_number: data.gst_number || "",
        gst_img: gstUrl || "",

        // Bank Details
        bank_name: data.bank_name,
        beneficiary_name: data.beneficiary_name,
        account_number: data.account_number,
        ifsc_code: data.ifsc_code,
        cancelled_cheque_img: checkLeafUrl,

        // Agreement
        registration_document_img: registrationDocumentUrl || "",
        agreement_pdf: agreementPdfUrl || "",

        // Audit
        created_by: 1,
      };

      setIsSubmitting(true);

      let res;

      if (id) {
        res = await FranchisePageServices.updateFranchisePage(id, payload);
      } else {
        res = await FranchisePageServices.addfranchisePage(payload);
      }

      setIsUpdate(true);
      setIsSubmitting(false);
      closeDrawer();

      notifySuccess(res.message);
    } catch (err) {
      notifyError(err?.response?.data?.message || err.message);
      setIsSubmitting(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      (async () => {
        try {
          const res = await FranchisePageServices.getFranchisePageById(id);

          if (res) {
            const Response = res.data;

            // Basic Details
            setValue("company_name", Response.company_name);
            setValue("owner_name", Response.owner_name);
            setValue("email_id", Response.email_id);
            setValue("phone_no", Response.phone_no);
            setValue("password", Response.password);
            setValue("address", Response.address);
            setValue("pincode", Response.pincode);

            // setSelectedCity(Response.city?.id || null);
            // setSelectedState(Response.state?.id || null);
            setSelectedCity(
              Response.city
                ? {
                    value: Number(Response.city.id),
                    label: Response.city.name,
                  }
                : null,
            );

            setSelectedState(
              Response.state
                ? {
                    value: Number(Response.state.id),
                    label: Response.state.name,
                  }
                : null,
            );

            // Service Details
            setSelectedServiceState(
              Response.service_states?.map((state) => ({
                value: state.id,
                label: state.name,
              })) || [],
            );
            setSelectedCities(
              Response.service_cities?.map((city) => city.id) || [],
            );

            // PAN / GST
            setValue("pan_number", Response.pan_number);
            setPanUrl(Response.pan_img);

            setValue("gst_number", Response.gst_number);
            setGstUrl(Response.gst_img);

            // Bank Details
            setValue("bank_name", Response.bank_name);
            setValue("beneficiary_name", Response.beneficiary_name);
            setValue("account_number", Response.account_number);
            setValue("ifsc_code", Response.ifsc_code);
            setCheckLeafUrl(Response.cancelled_cheque_img);
            // Agreement
            setRegistrationDocumentUrl(
              Response.registration_document_img || "",
            );
            setAgreementPdfUrl(Response.agreement_pdf || "");

            // Other
            setSelectedServices(Response.service_type || []);
            setValue("service_type", Response.service_type || []);
          }
        } catch (err) {
          notifyError(err?.response?.data?.message || err.message);
        }
      })();
    }

    if (!id) {
      clearErrors();

      setStep(1);

      setSelectedCompanyValue("Company");

      setSelectedCity(null);
      setSelectedState(null);

      setSelectedServiceState([]);
      setSelectedCities([]);

      // Basic Details
      setValue("company_name");
      setValue("owner_name");
      setValue("email_id");
      setValue("phone_no");
      setValue("password");
      setValue("address");
      setValue("pincode");

      // PAN / GST
      setValue("pan_number");
      setPanUrl("");

      setValue("gst_number");
      setGstUrl("");

      // Bank Details
      setValue("bank_name");
      setValue("beneficiary_name");
      setValue("account_number");
      setValue("ifsc_code");

      setCheckLeafUrl("");

      // Agreement

      setRegistrationDocumentUrl("");
      setAgreementPdfUrl("");
      // Services
      setSelectedServices([]);
      setValue("service_type", []);

      // Reset images
      setIDProofUrl("");
    }

    // eslint-disable-next-line
  }, [id, isDrawerOpen, setValue, clearErrors]);
  return {
    trigger,
    register,
    handleSubmit,
    onSubmit,
    errors,
    handleNextStep,
    step,
    setStep,
    handlePreviousStep,
    goToStep,
    setSelectedRadioValueGender,
    setSelectedCompanyValue,
    setSelectedCity,
    setSelectedState,
    setSelectedCountryId,
    setSelectedVendorValue,
    setSelectedFleetTypeValue,
    setSelectedCountrycode,
    setCheckLeafUrl,
    setPanUrl,
    setIDProofUrl,
    setGstUrl,
    idProofUrl,
    panUrl,
    gstUrl,
    checkLeafUrl,
    isSubmitting,
    selectedCompanyValue,
    selectedCity,
    selectedState,
    selectedCountryId,
    selectedProof,
    selectedRole,
    selectedCountryCode,
    selectedVendorValue,
    selectedFleetTypeValue,
    selectedRadioValueGender,
    registrationDocumentUrl,
    setRegistrationDocumentUrl,
    agreementPdfUrl,
    setAgreementPdfUrl,
    selectedServices,
    setSelectedServices,
    handleChangeCompany,
    handleChangeFleetType,
    handleChangeProof,
    handleChangeRadioGender,
    handleChangeVendorType,
    handleServiceChange,
    handleCityChange,
    handleCountryChange,
    handleStateChange,
    fleetContent,
    companyContent,
    setselectedRole,
    patternProof,
    palaceholderProof,
    handleYearChange,
    selectedYear,

    selectedCities,
    setSelectedCities,
    selectedServiceState,
    setSelectedServiceState,
    loading,
    setLoading,
    handleServiceStateChange,
  };
};

export default useFranchiseSubmit;
